import { defineComponent, computed, ref, watch } from "vue";
import { p as pick_1 } from "../../../vendor-b303cd6e.mjs";
import { u as useAvatarProps } from "./hooks/useAvatarProps-7897713e.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { V as VaIcon } from "../va-icon/index-7fefcddb.mjs";
import { V as VaProgressCircle } from "../va-progress-circle/index-ad19302c.mjs";
import { V as VaFallback } from "../va-fallback/index-c7099275.mjs";
import { f as filterComponentProps } from "../../utils/component-options/filter-props-9727421a.mjs";
import { u as useLoadingProps } from "../../composables/useLoading-5a447e96.mjs";
import { u as useSizeProps, a as useSize } from "../../composables/useSize-73067570.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../composables/useColors-cd2c0b98.mjs";
import { u as useTextColor } from "../../composables/useTextColor-19f6bd95.mjs";
import { u as useBem } from "../../composables/useBem-a19cd502.mjs";
const VaFallbackProps = extractComponentProps(VaFallback);
const _sfc_main = defineComponent({
  name: "VaAvatar",
  components: { VaIcon, VaProgressCircle, VaFallback },
  props: {
    ...useLoadingProps,
    ...useSizeProps,
    ...useComponentPresetProp,
    ...useAvatarProps,
    ...VaFallbackProps,
    src: { type: String, default: null },
    icon: { type: String, default: "" },
    alt: { type: String, default: "" }
  },
  emits: ["error", "fallback"],
  setup(props, { emit }) {
    const { getColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    const backgroundColorComputed = computed(() => {
      if (props.loading || props.src && !hasLoadError.value) {
        return "transparent";
      }
      return colorComputed.value;
    });
    const { sizeComputed, fontSizeComputed } = useSize(props, "VaAvatar");
    const { textColorComputed } = useTextColor();
    const computedStyle = computed(() => ({
      fontSize: props.fontSize || fontSizeComputed.value
    }));
    const classesComputed = useBem("va-avatar", () => ({
      ...pick_1(props, ["square"])
    }));
    const hasLoadError = ref(false);
    const onLoadError = (event) => {
      hasLoadError.value = true;
      emit("error", event);
    };
    watch(() => props.src, () => {
      hasLoadError.value = false;
    });
    const avatarOptions = computed(() => ({
      hasError: hasLoadError.value,
      onError: onLoadError
    }));
    return {
      hasLoadError,
      sizeComputed,
      avatarOptions,
      computedStyle,
      colorComputed,
      classesComputed,
      textColorComputed,
      backgroundColorComputed,
      VaFallbackProps: filterComponentProps(VaFallbackProps),
      onLoadError
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaAvatar.vue_vue_type_script_lang-c324c56e.mjs.map
